import React from 'react'
import { Field } from 'react-final-form'
import PropTypes from 'prop-types';
import localization from '../helpers/localization.js';


const InputWithLabel = (props) => {
    if (props.type != "file") {
        return (
            <Field name={props.name} type={props.type} validate={(value) => props.validator ? props.validator.validate(value) : ""} >
                {({ input, meta }) => (
                    <div className="inputWithLabel">
                        <label htmlFor={props.name} className="textinputLabel">{props.label} </label>
                        <input {...input} type={props.type} placeholder={props.placeHolder} />
                        <InfoLink infoLink={props.infoLink} />
                        {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
                    </div>
                )}
            </Field>
        );
    }
    else
        return FileField(props);
}

const FileField = (props) => {
    return (<Field type="FileList" name={props.name}>
        {({ input: { value, onChange, ...input }, meta }) => (
            <div className="inputWithLabel">
                <label htmlFor={props.name} className="textinputLabel">{props.label} </label>
                <input
                    {...input}
                    type="file"
                    onChange={({ target }) => onChange(Array.from(target.files))}
                    {...props}
                />
                {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
            </div>
            )}
        </Field>)
        }
export default InputWithLabel

InputWithLabel.propTypes = {
    name: PropTypes.string.isRequired
};

let InfoLink = ({ infoLink }) => {
    if (infoLink) {
        return (<span><a href={infoLink} target="_blank">{localization.privacyStatement}</a><br /></span>);
    }
    else {
        return null;
    }
}